import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import CardOrders from '../component/c-orders/cardOrders';
import { UserDeCartItems } from '../api/apiService';
import { useParams } from 'react-router-dom'; // ✅ import useParams

const useStyles = makeStyles({
    list: {
        width: 500,
        background: '#efefef',
        height: '100%',
    },
    fullList: {
        width: 'auto',
    },
});

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            {...other}
            style={{ height: "100%", overflowY: "auto" }}
        >
            {value === index && <Box p={2}>{children}</Box>}
        </div>
    );
}

export default function DrawerRight(props) {
    const classes = useStyles();
    const { userId } = useParams(); // ✅ get userId from URL
    const [state, setState] = React.useState({
        right: false
    });

    const [cartData, setCartData] = useState(props.data || []);
    const [deCartData, setDeCartData] = useState([]);
    const [loadingDeCart, setLoadingDeCart] = useState(false);
    const [tabValue, setTabValue] = useState(0);

    useEffect(() => {
        setCartData(props.data || []);
    }, [props.data]);

    // 🔑 API call when DeCart tab is selected
    useEffect(() => {
        const fetchDeCartData = async () => {
            try {
                setLoadingDeCart(true);
                const response = await UserDeCartItems(userId); // ✅ pass userId
                setDeCartData(response?.data?.data.cartItems || []);
            } catch (error) {
                console.error("Failed to fetch DeCart items:", error);
                setDeCartData([]);
            } finally {
                setLoadingDeCart(false);
            }
        };

        if (tabValue === 1 && userId) {
            fetchDeCartData();
        }
    }, [tabValue, userId]);

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };

    return (
        <React.Fragment>
            <button
                onClick={toggleDrawer("right", true)}
                type="button"
                className="btn btn-verify"
            >
                Card items
            </button>

            <Drawer
                anchor="right"
                open={state["right"]}
                onClose={toggleDrawer("right", false)}
            >
                <div className={clsx(classes.list)} style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                    {/* Tabs Header */}
                    <div
                        style={{
                            position: "sticky", // ✅ keeps it fixed inside drawer
                            top: 0,
                            background: "#efefef", // same as drawer bg
                            zIndex: 10,
                            textAlign: "center"
                        }}
                    >
                        <Tabs
                            value={tabValue}
                            onChange={(e, newValue) => setTabValue(newValue)}
                            indicatorColor="primary"
                            textColor="primary"
                            centered // ✅ center the tabs
                        >
                            <Tab label="Food Cart" />
                            <Tab label="DeCart" />
                        </Tabs>
                    </div>

                    {/* Scrollable content */}
                    <div style={{ flex: 1, overflowY: "auto" }}>
                        {/* Food Cart Tab */}
                        <TabPanel value={tabValue} index={0}>
                            {cartData && cartData.length !== 0 ? (
                                cartData.map((i, index) => (
                                    <div key={i._id} className="m-4">
                                        <CardOrders title={`Item : ${index + 1}`} data={i} />
                                    </div>
                                ))
                            ) : (
                                <div className="card-not-fund family-Courgette">
                                    <img src="../../../assate/images/add_friends.svg" alt="logo" />
                                    <h4>Cart Items Not Found</h4>
                                </div>
                            )}
                        </TabPanel>

                        {/* DeCart Tab */}
                        <TabPanel value={tabValue} index={1}>
                            {loadingDeCart ? (
                                <p>Loading DeCart Items...</p>
                            ) : deCartData && deCartData.length !== 0 ? (
                                deCartData.map((i, index) => (
                                    <div key={i._id || index} className="m-4">
                                        <div className="category-container">
                                            <div className="user-order-container">
                                                <h4 className="family-Courgette">Item {index + 1}</h4>
                                                <table className="details" style={{ minWidth: "100%" }}>
                                                    <tbody>
                                                        <tr>
                                                            <td><b>Product:</b></td>
                                                            <td>
                                                                <span>{i?.productId?.product_name}</span>
                                                                <span className="badge badge-dark"> x {i.quantity}</span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Price without tax:</b></td>
                                                            <td>₹ {parseFloat(i.productId?.sellPrice).toFixed(2)}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Food Value:</b></td>
                                                            <td>
                                                                ₹{parseFloat(i.productId?.sellPrice).toFixed(2)}X{parseFloat(i.quantity)} ={" "}
                                                                <span className="badge badge-dark">
                                                                    ₹ {(parseFloat(i.productId?.sellPrice) * parseFloat(i.quantity)).toFixed(2)}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="card-not-fund family-Courgette">
                                    <img src="../../../assate/images/add_friends.svg" alt="logo" />
                                    <h4>DeCart Items Not Found</h4>
                                </div>
                            )}
                        </TabPanel>
                    </div>
                </div>
            </Drawer>
        </React.Fragment>
    );
}
